import React from "react";
import { Link } from "react-router-dom";
import errorimage from "../assets/error.png";

const ErrorPage = () => {
  return (
    <div>
      <div className="container error">
        <div className="row justify-content-center">
          <div className="col-sm-8 col-sm-6">
            <div className="text-center">
              <img src={errorimage} alt="Error found" className="img-fluid" />
              <h3 className="my-1 fw-bold">Page Not Found</h3>
              <p>Oops! The page you're looking for doesn't exist.</p>
              <Link to="/" className="btn btnadd">
                Back to Home Page
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
